// TODO: Replace with the real values
export const RESOURCE_NAME = 'location_aggregation';

export const ENTITY_NAME = 'locationsStatistics';
